import { refreshApplicationsMenu } from '../utils/applications';
import { useUserStore } from 'vince-core/stores/userStore';

export const useAppsRefreshMenu = () => {
    const userStore = useUserStore();
    const { userInfo } = storeToRefs(userStore);
    const route = useRoute();

    // Dont load the apps menu when in apps-fullscreen layout
    // only load it when leaving the apps-fullscreen layout or when userInfo is set
    watch(userInfo, (newVal) => {
        if (newVal !== undefined && route.meta.layout !== 'apps-fullscreen') {
            refreshApplicationsMenu();
        }
    });

    watch(() => route.meta.layout, (layout, oldLayout) => {
        if (oldLayout === 'apps-fullscreen' && layout !== 'apps-fullscreen' && userInfo.value !== undefined) {
            refreshApplicationsMenu();
        }
    });
};
